/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/dashboard" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('src/views/Login'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('src/views/Error401'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('src/views/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('src/views/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/dashboard',
        exact: true,
        component: lazy(() => import('src/views/Calendar'))
      },
      {
        path: '/candidates/:rowsPerPage?/:searchText?',
        exact: true,
        component: lazy(() => import('src/views/CandidatesList'))
      },
      {
        path: '/candidates/details/:id',
        exact: true,
        component: lazy(() => import('src/views/CandidatesDetails'))
      },
      {
        path: '/candidates/details/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/CandidatesDetails'))
      },
      {
        path: '/clients/:rowsPerPage?/:searchText?',
        exact: true,
        component: lazy(() => import('src/views/ClientsList'))
      },
      {
        path: '/mentors/:rowsPerPage?/:searchText?',
        exact: true,
        component: lazy(() => import('src/views/MentorsList'))
      },
      {
        path: '/mentors/details/:id',
        exact: true,
        component: lazy(() => import('src/views/Mentor'))
      },
      {
        path: '/mentors/details/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/Mentor'))
      },
      {
        path: '/clients/details/:id',
        exact: true,
        component: lazy(() => import('src/views/ClientDetails'))
      },
      {
        path: '/clients/details/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/ClientDetails'))
      },
      {
        path: '/managers',
        exact: true,
        component: lazy(() => import('src/views/ManagersList'))
      },
      {
        path: '/managers/details/:id',
        exact: true,
        component: lazy(() => import('src/views/ManagerDetails'))
      },
      {
        path: '/managers/details/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/ManagerDetails'))
      },
      {
        path: '/competencies',
        exact: true,
        component: lazy(() => import('src/views/CompetencyList'))
      },
      {
        path: '/competency/:id',
        exact: true,
        component: lazy(() => import('src/views/CompetencyAreas'))
      },
      {
        path: '/practiceArea/:id',
        exact: true,
        component: lazy(() => import('src/views/PracticeSkills'))
      },
      {
        path: '/practiceSkill/:id',
        exact: true,
        component: lazy(() => import('src/views/PracticeSkillGroups'))
      },
      {
        path: '/practiceSkillGroup/:id',
        exact: true,
        component: lazy(() => import('src/views/PracticeSubSkills'))
      },
      {
        path: '/categories',
        exact: true,
        component: lazy(() => import('src/views/CategoriesList'))
      },
      {
        path: '/secondarycategories',
        exact: true,
        component: lazy(() => import('src/views/SecondaryCategoriesList'))
      },
      {
        path: '/admins',
        exact: true,
        component: lazy(() => import('src/views/AdminsList'))
      },
      {
        path: '/admins/:id',
        exact: true,
        component: lazy(() => import('src/views/AdminDetails'))
      },
      {
        path: '/admins/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/AdminDetails'))
      },
      {
        path: '/advice',
        exact: true,
        component: lazy(() => import('src/views/AdviceList'))
      },
      {
        path: '/advice/create/:tab',
        exact: true,
        component: lazy(() => import('./views/Advice/CreateAdvice'))
      },
      {
        path: '/advice/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/Advice/UpdateAdvice'))
      },
      {
        path: '/courses',
        exact: true,
        component: lazy(() => import('./views/CoursesView'))
      },
      {
        path: '/course/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/CreateCourse'))
      },
      {
        path: '/courses/create',
        exact: true,
        component: lazy(() => import('./views/CreateCourse'))
      },
      {
        path: '/courses/create/:tab',
        exact: true,
        component: lazy(() => import('./views/CreateCourse'))
      },
      {
        path: '/instance/create/:courseID',
        exact: true,
        component: lazy(() =>
          import('./views/CreateCourse/Instances/InstanceEdit')
        )
      },
      {
        path: '/tutors',
        exact: true,
        component: lazy(() => import('src/views/TutorsList'))
      },
      {
        path: '/tutor/create/:tab',
        exact: true,
        component: lazy(() => import('./views/Tutor/CreateTutor'))
      },
      {
        path: '/tutor/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/Tutor/UpdateTutor'))
      },
      {
        path: '/instance/:ident',
        exact: true,
        component: lazy(() =>
          import('./views/CreateCourse/Instances/InstanceEdit')
        )
      },
      {
        path: '/tests',
        exact: true,
        component: lazy(() => import('./views/TestsList'))
      },
      {
        path: '/test/create/:tab',
        exact: true,
        component: lazy(() => import('./views/Test/CreateTest'))
      },
      {
        path: '/test/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/Test/UpdateTest'))
      },
      {
        path: '/modules',
        exact: true,
        component: lazy(() => import('./views/ModulesList'))
      },
      {
        path: '/modules/create/:tab',
        exact: true,
        component: lazy(() => import('./views/Module/CreateModule'))
      },
      {
        path: '/modules/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/Module/UpdateModule'))
      },
      {
        path: '/questions',
        exact: true,
        component: lazy(() => import('./views/QuestionsList'))
      },
      {
        path: '/questions/create/:tab',
        exact: true,
        component: lazy(() => import('./views/Question/CreateQuestion'))
      },
      {
        path: '/question/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/Question/UpdateQuestion'))
      },
      {
        path: '/lessons',
        exact: true,
        component: lazy(() => import('./views/LessonsList'))
      },
      {
        path: '/lessons/create/:tab',
        exact: true,
        component: lazy(() => import('./views/Lesson/CreateLesson'))
      },
      {
        path: '/lesson/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/Lesson/UpdateLesson'))
      },
      {
        path: '/certificateTypes',
        exact: true,
        component: lazy(() => import('./views/CertificateTypesList'))
      },
      {
        path: '/certificateTypes/create/:tab',
        exact: true,
        component: lazy(() =>
          import('./views/CertificateType/CreateCertificateType')
        )
      },
      {
        path: '/certificateTypes/:ident/:tab',
        exact: true,
        component: lazy(() =>
          import('./views/CertificateType/UpdateCertificateType')
        )
      },
      {
        path: '/popular-courses',
        exact: true,
        component: lazy(() => import('src/views/PopularCourses'))
      },
      {
        path: '/tags',
        exact: true,
        component: lazy(() => import('src/views/Tags'))
      },
      {
        path: '/socialEvents',
        exact: true,
        component: lazy(() => import('src/views/SocialEventsList'))
      },
      {
        path: '/socialEvents/:id',
        exact: true,
        component: lazy(() => import('src/views/SocialEventDetails'))
      },
      {
        path: '/socialEvents/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/SocialEventDetails'))
      },
      {
        path: '/characterSuitability',
        exact: true,
        component: lazy(() => import('./views/CharacterSuitability'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];
